import React from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'cdk-radial';
import { DMSDropdown } from './DMSSelector';
import { ACTIONS } from '../../utils/daabSubscriptions';
import './DAABSubscriptions.scss';
import _ from 'lodash';

const DepartmentsBlock = (props) => {
  const {
    entityDMS,
    apiDMS = [],
    locationId,
    selectedByType,
    onDMSSelect,
  } = props;

  if (entityDMS?.status === 'LOADING') {
    return (
      <div className="dms-container centered">
        <Loader />
      </div>
    );
  }

  if (entityDMS?.status === 'ERROR') {
    return (
      <>
        <div className="heading">Departments</div>
        <div className="dms-container centered">
          <div className="sub-heading error">
            Error while fetching DMS data, try again after sometime.
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="heading">Departments</div>
      {apiDMS.map((type) => {
        const selectedDms = selectedByType[type] || [];
        return (
          <div className="dms-container" key={type}>
            <div className="dms-name">{type} DMS Account</div>
            <div className="dropdown-container">
              <DMSDropdown
                dmsType={type}
                dmsOptions={entityDMS.departments[type]}
                id={locationId}
                onDMSSelect={onDMSSelect}
                selectedDms={selectedDms}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export const LocationBlock = (props) => {
  const {
    locationId,
    locationData,
    entityDMS = {},
    subscribeRequest,
    onDMSSelect,
    apiDMS,
    className
  } = props;
  const selectedDms = subscribeRequest[locationId]?.dmsConfig || [];
  const selectedByType = _.groupBy(selectedDms, 'dmsType');

  return (
    <section className={`dms-location-block ${className}`}>
      <div className="heading">Dealership</div>
      <div className="location-details">
        <div className="name">{locationData.location}</div>
        <div className="address">{locationData.address}</div>
        <div className="cmf-number">CMF {locationData.cmfNumber}</div>
      </div>
      <DepartmentsBlock
        entityDMS={entityDMS}
        locationId={locationId}
        selectedByType={selectedByType}
        onDMSSelect={onDMSSelect}
        apiDMS={apiDMS}
      />
    </section>
  );
};

export const SelectDMS = ({ selectedAPI, handleLocationSelection }) => {
  const state = useSelector((state) => state);
  const {
    subscribeRequest,
    dmsByEntity = {},
    dmsSupportedApis = {},
  } = state?.daabSubscriptionsSlice;
  const { id, name, type } = selectedAPI;
  const apiDMS = dmsSupportedApis[id] || [];

  const onDMSSelect = (locationId, dmsType, selectedOptions) => {
    const selectedDms = subscribeRequest[locationId]?.dmsConfig || [];
    const selectedByType = _.groupBy(selectedDms, 'dmsType');
    selectedByType[dmsType] = selectedOptions;
    const updatedDmsConfig = _.flatMap(selectedByType);
    handleLocationSelection({
      locationData: { entityId: locationId },
      action: ACTIONS.UPDATE_DMS,
      dmsConfig: updatedDmsConfig,
    });
  };

  return (
    <>
      <div className="add-locations-subheader">
        Review your DMS accounts for accuracy. Contact your accounting office if unsure.
      </div>

      {Object.entries(subscribeRequest).map(([entityId, data]) => (
        <LocationBlock
          className='dms-box-size'
          key={entityId}
          locationId={entityId}
          locationData={data}
          entityDMS={dmsByEntity[entityId]}
          onDMSSelect={onDMSSelect}
          subscribeRequest={subscribeRequest}
          apiDMS={apiDMS}
        />
      ))}
    </>
  );
};
